module.exports = __webpack_public_path__ + "static/media/specialities-header.79e82a52.jpg";